import { createFileRoute } from "@tanstack/react-router";

import { CONTENT_CALENDAR_FAQS } from "@/components/marketing/content-calendar-faqs";
import { ContentCalendarTool } from "@/components/marketing/content-calendar-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so the FAQs live in their own module rather than
 * being imported from the page component. See `tools.thread-splitter.tsx`.
 */
export const Route = createFileRoute("/(public)/tools/content-calendar-2027")({
  head: () => toolPageHead("contentCalendar2027", CONTENT_CALENDAR_FAQS),
  component: ContentCalendarTool,
});
